import React from "react";

const StatusField = ({
  label,
  status,
  type,
  register,
  inputProps = "",
  errors,
  name = "",
  defaultValue = "",
  disabled = false,
  watch,
  isStepVisited,
}) => {
  return (
    <>
      <label
        className={
          isStepVisited() &&
          watch("availableForSale") === false &&
          watch("availableForRent") === false
            ? "text-danger"
            : ""
        }
      >
        {label}
      </label>
      <label className="check-box input-style bg-white" style={{
        padding:"0px 0px 0px 35px"
      }}>
        {" "}
        &nbsp; {status}
        <input type={type} name={name} {...register} disabled={disabled} />
        <span className="checkmark"></span>
      </label>
    </>
  );
};

export default StatusField;
